import PropTypes from 'prop-types';
// material
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object,
};

export default function Logo({ sx }) {
  return (
    <Box
      component='img'
      src='https://res.cloudinary.com/belong/image/upload/v1629792864/uploaded_resources/logo_exlnou.png'
      sx={{ width: 'auto', height: 40, ...sx }}
    />
  );
}
